<script lang="ts">
    import type {DirectoryNode} from 'src/typings';
    import type {MediaViewerFile} from 'src/features/media-viewer/lib/mv-types';
    import {onDestroy, onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import MvTreeColumnFile from '../MvTreeColumnFile.svelte';
    import {getMediaViewerContext} from '../../../../lib/mv-context';
    import {FILE_LEFT_ARROW_EVENT, getTreeViewEventContext} from './event-context';

    export let file: MediaViewerFile;
    export let parentDirectory: DirectoryNode | null = null;
    export let level = 1;

    const context = getMediaViewerContext();
    const treeViewEventBus = getTreeViewEventContext();

    let dragged = false;
    let currentFileChecked = false;
    const currentSelectedFilesUnsubscribe = context.filesSelected.subscribe((currentFilesSelected) => {
        currentFileChecked = exists(currentFilesSelected.find((e) => e.id === file.id));
    });

    onMount(() => {
        treeViewEventBus.addEventListener(FILE_LEFT_ARROW_EVENT, handleLeftArrowEvent);
    });

    onDestroy(() => {
        currentSelectedFilesUnsubscribe();

        treeViewEventBus.removeEventListener(FILE_LEFT_ARROW_EVENT, handleLeftArrowEvent);
    });

    const handleLeftArrowEvent = (event: CustomEvent<number>) => {
        if (event.detail !== file.id) {
            return;
        }

        if (exists(parentDirectory)) {
            const parentElement = document.getElementById(`tree-view-directory-${parentDirectory.id}`);
            parentElement?.focus();
        }
    }

    const handleDragStart = (event: DragEvent) => {
        dragged = true;
        event.dataTransfer.setData('application/json', JSON.stringify({
            file,
            originalDirectory: parentDirectory
        }));
        event.dataTransfer.effectAllowed = 'move';
    }

    const handleDragEnd = () => {
        dragged = false;
    };
</script>

<div id="file-{file.id}"
     class="mv-tree-column-file"
     aria-level={level}
     draggable="true"
     tabindex="0"
     on:dragstart={handleDragStart}
     on:dragend={handleDragEnd}
     aria-selected={currentFileChecked}
     role="treeitem">

    <MvTreeColumnFile id="tree-view-file-{file.id}"
                      {dragged}
                      {file}
                      {parentDirectory}/>
</div>